export const OG_IMAGE_EXTENSIONS = ['jpeg', 'gif', 'png', 'jpg', 'webp']
